module.exports = __webpack_public_path__ + "static/media/Input Manufacturer - GBR care Infographic Mobile 05-03-2024 .cf312a38.gif";